import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import Layout from "../components/Layout/Layout";
import NavBar from '../components/NavBar/NavBar';

import { getMissionStatus } from "../api/getMissionStatus";
import { updateMissionStatus } from "../api/updateMissionStatus";
import { getMissions } from "../api/getMissions";
import {finished} from '../api/directAdmin'

import rocketIcon from '../assets/rocketIcon.png';
import moveIcon from '../assets/moveIcon.png';
import tickIcon from '../assets/tickIcon.png';
import notificationIcon from '../assets/notificationIcon.png';
import expandIcon from '../assets/expandIcon.png';
import collapseIcon from '../assets/collapseIcon.png';

import { formatNumber } from '../utils/formatNumber';

const Earn = () => {
    const token = sessionStorage.getItem('token');
    const navigate = useNavigate();
    const [missions, setMissions] = useState([]);
    const [missionStatus, setMissionStatus] = useState({});
    const [notification, setNotification] = useState('');
    const [notificationVisibile, setNotificationVisibile] = useState('false');
    const [isLoading, setIsLoading] = useState(true);
    const [isEssentialTasksCollapsed, setIsEssentialTasksCollapsed] = useState(false);
    const [isBonusTasksCollapsed, setIsBonusTasksCollapsed] = useState(false);
    const [isAccessing, setIsAccessing] = useState(false);
    const [siteURL, setSiteURL] = useState("https://discord.com/invite/bluemoon/");

    useEffect(() => {
        const initiateMissionStatus = async () => {
            const missionData = await getMissions(token);
            const initialMissionStatus = await getMissionStatus(token);
            const aliveMissions = missionData.filter(miss=>miss.is_live);
            setMissions(aliveMissions.map(mission=>{
                mission.photoUrl = `https://storage.googleapis.com/bluemoon_task_images//${mission.photoUrl}?authuser=0`;
                return mission;
            }));
            setMissionStatus(initialMissionStatus);
            setIsLoading(false);
        }
        initiateMissionStatus();
    }, []);

    const toggleEssentialTasksCollapse = () => {
        setIsEssentialTasksCollapsed(!isEssentialTasksCollapsed);
    };

    const toggleBonusTasksCollapse = () => {
        setIsBonusTasksCollapsed(!isBonusTasksCollapsed);
    };


    const handleClickMission = async (missionId) => {
        const mission = missions.find(m => m._id === missionId);
        const apiResult = await updateMissionStatus(token, missionId);
        if (mission.inviteCount > 0) {
            if (apiResult === false) {
                setNotification(`Task not completed`);
                setNotificationVisibile(true);

                setTimeout(() => {
                    setNotificationVisibile(false);
                    setTimeout(() => setNotification(''), 3000);
                }, 2000);
            } else {
                setNotification(`Task completed`);
                setNotificationVisibile(true);
                finished(mission._id);

                setTimeout(() => {
                    setNotificationVisibile(false);
                    setTimeout(() => setNotification(''), 3000);
                }, 2000);
            }
        } else {
            let missionStatue = missionStatus;
            let arr = missionStatue.missions;
            finished(mission._id);
            missionStatue.missions = arr.push(mission._id);
            setMissionStatus(missionStatue);
            // window.location.href = mission.link;
            if(mission.link !== ""){
                openInSafari(mission.link);
                // alert(siteURL);
                // setIsAccessing(true);
                // await window.open(mission.link);
                navigate('/?from=browser');
            }
            // return false
        }
    }

    const openInSafari = (url) => {
        window.location.href = url;
    }

    const goBackToApp = () =>{
        setIsAccessing(false);
        setIsLoading(false);
    }

    const [allCoinsByEtask, setAllCoinsByEtask] = useState(0);
    const [allCoinsByBtask, setAllCoinsByBtask] = useState(0);

    useEffect(()=>{
        let bcoins = 0;
        let ecoins = 0;
        missions?.map(mission=>{
            if(mission.earnType === 'essential') ecoins += mission.bonus;
            else if(mission.earnType === 'bonus') bcoins += mission.bonus;
        })
        setAllCoinsByBtask(bcoins);
        setAllCoinsByEtask(ecoins);
    }, [missions])

    return (
        // isAccessing ? (
        //     <div style={{height:'100%', width:'100%', display:"flex", flexDirection:"column"}}>
        //         <button style={{ width: '100%', padding:"10px 0px", background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', cursor: 'pointer', border: 'none', fontFamily: 'Poppins', color: 'white', fontSize: '1rem', fontWeight: '600' }} onClick={goBackToApp}>Back To App</button>            
        //         {/* <iframe style={{height:'100%', width:'100%', border:"none"}} referrerpolicy="no-referrer" src="https://discord.com" title="description" allowFullScreen></iframe> */}
        //     </div>
        // ) : (
        <Layout>
            {isLoading ? (
                <div className="loading-container">
                    <div className="spinner"></div>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', paddingBlock: '1.5rem', position: 'relative' }}>
                    <img src={rocketIcon} alt="Rocket Icon" style={{ marginTop: '1.25rem', width: '5rem', height: '5rem' }} />
                    <span style={{ marginTop: '1.75rem', color: 'white', fontFamily: 'Poppins', fontSize: '1.5rem', marginBottom:"8px" , fontWeight: '600' }}>Earn more Mooncoins</span>
                    <div style={{ width: '100%', paddingInline: '2.5rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                        <div style={{ padding: '1.5625rem', display: 'flex', flexDirection: 'column', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', borderRadius: '1.25rem' }}>
                            <span style={{ color: 'white', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1rem' }}>New Tasks</span>
                            <div style={{ width: '100%', marginTop: '1.375rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'column', gap: '1rem' }}>
                                {missions.map(mission => (
                                    mission.earnType === 'new' && (
                                        <button key={mission._id} style={{ border: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: missionStatus.missions.includes(mission._id) ? 'auto' : 'pointer', background: 'transparent', width: '100%', opacity: missionStatus.missions.includes(mission._id) ? '0.1' : '1' }} onClick={missionStatus.missions.includes(mission._id) ? null : () => handleClickMission(mission._id)}>
                                            <img src={mission.photoUrl} alt={mission.title} style={{ width: '2rem', height: '2rem', background: 'rgba(140,140,140,0.1)', borderRadius: '50%', padding: '0.2rem' }} />
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', marginLeft: '1rem', width: '100%' }}>
                                                <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '0.75rem', color: 'white',textAlign:"left"}}>{mission.description}</span>
                                                <div style={{textAlign:"start", fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)' }}>
                                                    Earn
                                                    <span style={{ fontWeight: '600', marginInline: '0.2rem', color: 'white' }}>+{formatNumber(mission.bonus)}</span>
                                                    Mooncoins
                                                </div>
                                            </div>
                                            {missionStatus.missions.includes(mission._id) ? (
                                                <img src={tickIcon} alt="Tick Icon" style={{ width: '1rem', height: '0.8rem' }} />
                                            ) : (
                                                <img src={moveIcon} alt="Move Icon" style={{ width: '1rem', height: '0.8rem' }} />
                                            )}
                                        </button>
                                    )
                                ))}
                            </div>
                        </div>
                        <div style={{ padding: '1.5625rem', display: 'flex', flexDirection: 'column', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', borderRadius: '1.25rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={toggleEssentialTasksCollapse}>
                                <span style={{ color: 'white', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1rem' }}>Essential Tasks</span>
                                {isEssentialTasksCollapsed ? <p style={{color:"#4a9af6", fontSize:"11px"}}>+{formatNumber(allCoinsByEtask)} MoonCoins</p> : ""}
                                <div style={{ background: 'transparent', border: 'none', color: 'white' }}>
                                    {isEssentialTasksCollapsed ? (
                                        <img src={expandIcon} alt="Expand Icon" style={{ width: '1rem', height: '1rem' }}></img>
                                    ) : (
                                        <img src={collapseIcon} alt="Collapse Icon" style={{ width: '1rem', height: '1rem' }}></img>
                                    )}
                                </div>
                            </div>
                            {!isEssentialTasksCollapsed && (
                                <div style={{ width: '100%', marginTop: '1.375rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'column', gap: '1rem' }}>
                                    {missions.map(mission => (
                                        mission.earnType === 'essential' && (
                                            <button  key={mission._id} style={{ border: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: missionStatus.missions.includes(mission._id) ? 'auto' : 'pointer', background: 'transparent', width: '100%', opacity: missionStatus.missions.includes(mission._id) ? '0.1' : '1' }} onClick={missionStatus.missions.includes(mission._id) ? null : () => handleClickMission(mission._id)}>
                                                <img src={mission.photoUrl} alt={mission.title} style={{ width: '2rem', height: '2rem', background: 'rgba(140,140,140,0.1)', borderRadius: '50%', padding: '0.2rem' }} />
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', marginLeft: '1rem', width: '100%' }}>
                                                    <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '0.75rem', color: 'white',textAlign:"left"}}>{mission.description}</span>
                                                    <div style={{textAlign:"start", fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)' }}>
                                                        Earn
                                                        <span style={{ fontWeight: '600', marginInline: '0.2rem', color: 'white' }}>+{formatNumber(mission.bonus)}</span>
                                                        Mooncoins
                                                    </div>
                                                </div>
                                                {missionStatus.missions.includes(mission._id) ? (
                                                    <img src={tickIcon} alt="Tick Icon" style={{ width: '1rem', height: '0.8rem' }} />
                                                ) : (
                                                    <img src={moveIcon} alt="Move Icon" style={{ width: '1rem', height: '0.8rem' }} />
                                                )}
                                            </button>
                                        )
                                    ))}
                                </div>
                            )}
                        </div>
                        <div style={{ padding: '1.5625rem', display: 'flex', flexDirection: 'column', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', borderRadius: '1.25rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={toggleBonusTasksCollapse}>
                                <span style={{ color: 'white', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1rem' }}>Bonus Tasks</span>
                                {isBonusTasksCollapsed ? <p style={{color:"#4a9af6", fontSize:"11px"}}>+{formatNumber(allCoinsByBtask)} MoonCoins</p> : ""}
                                <div style={{ background: 'transparent', border: 'none', color: 'white' }}>
                                    {isBonusTasksCollapsed ? (
                                        <img src={expandIcon} alt="Expand Icon" style={{ width: '1rem', height: '1rem' }}></img>
                                    ) : (
                                        <img src={collapseIcon} alt="Collapse Icon" style={{ width: '1rem', height: '1rem' }}></img>
                                    )}
                                </div>
                            </div>
                            {!isBonusTasksCollapsed && (
                                <div style={{ width: '100%', marginTop: '1.375rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'column', gap: '1rem' }}>
                                    {missions.map(mission => (
                                        mission.earnType === 'bonus' && (
                                            <button key={mission._id} style={{ border: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: missionStatus.missions.includes(mission._id) ? 'auto' : 'pointer', background: 'transparent', width: '100%', opacity: missionStatus.missions.includes(mission._id) ? '0.1' : '1' }} onClick={missionStatus.missions.includes(mission._id) ? null : () => handleClickMission(mission._id)}>
                                                <img src={mission.photoUrl} alt={mission.title} style={{ width: '2rem', height: '2rem', background: 'rgba(140,140,140,0.1)', borderRadius: '50%', padding: '0.4rem' }} />
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', marginLeft: '1rem', width: '100%' }}>
                                                    <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '0.75rem', color: 'white',textAlign:"left"}}>{mission.description}</span>
                                                    <div style={{textAlign:"start", fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)' }}>
                                                        Earn
                                                        <span style={{ fontWeight: '600', marginInline: '0.2rem', color: 'white' }}>+{formatNumber(mission.bonus)}</span>
                                                        Mooncoins
                                                    </div>
                                                </div>
                                                {missionStatus.missions.includes(mission._id) ? (
                                                    <img src={tickIcon} alt="Tick Icon" style={{ width: '1rem', height: '0.8rem' }} />
                                                ) : (
                                                    <img src={moveIcon} alt="Move Icon" style={{ width: '1rem', height: '0.8rem' }} />
                                                )}
                                            </button>
                                        )
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    {notification &&
                        <div style={{ position: 'absolute', bottom: '1rem', zIndex: '2', width: '100%' }}>
                            <div style={{ marginInline: '1.875rem', background: 'rgba(140, 140, 140, 0.1)', backdropFilter: 'blur(1rem)', WebkitBackdropFilter: 'blur(0.5rem)', borderRadius: '18.75rem', paddingBlock: '1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: notificationVisibile ? 1 : 0, transition: 'opacity 0.5s ease-out', pointerEvents: notificationVisibile ? 'auto' : 'none' }}>
                                <img src={notificationIcon} alt='Notification Icon' style={{ width: '1.5625rem', height: '1.5625rem' }} />
                                <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '1.5rem', color: 'white', marginLeft: '0.375rem' }}>{notification}</span>
                            </div>
                        </div>
                    }
                </div>
            )}
            <div style={{height: '65px'}}></div>
            <NavBar />
        </ Layout >
    )
    // );
};

export default Earn;